import { Component, Injector, Input, OnInit } from '@angular/core';
import { TableColumn } from '@models/tableColumn';
import { PricingsService } from '@services/entity/pricings.service';
import { StripeInfosService } from '@services/entity/stripe-infos.service';
import { plainToClass } from 'class-transformer';
import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { PricingDto } from '@dto/pricingDto';
import { TableOptions } from '@models/tableOptions';
import { UsersService } from '@services/entity/users.service';
import { CurrencyPipe } from '@angular/common';
import { CustomersService } from '@services/entity/customers.service';
import { BillingMethodEnum } from '@enums/billingMethodEnum.enum';
import { Pricing } from '../../../../models/pricing';

@Component({
  selector: 'app-pricings-table',
  templateUrl: './pricings-table.component.html',
  styleUrls: ['./pricings-table.component.scss'],
})
export class PricingsTableComponent extends AbstractEntitiesTableComponent implements OnInit {

  @Input() parent_operator: boolean;

  public className = 'PricingsTableComponent'

  public isOperatorView: boolean
  public entities: PricingDto[]
  public hasStripeAccount: boolean

  public userId: string;

  public user: boolean = false;
  public customer: boolean = false;
  public operator: boolean = false;
  public isSupporter: boolean = false;

  public tableColumns: TableColumn[] = [
    { columnDescription: `Typ`, property: 'type', options: {
      tdStyleClasses: 'type' } },

    { columnDescription: `Bezeichnung`, property: 'name', options: {
      tdStyleClasses: 'designation' } },

    { columnDescription: `Beschreibung`, property: 'description', options: {
      tdStyleClasses: 'description' } },

    { columnDescription: `Preis AC`, property: 'price', options: {
      tdStyleClasses: 'currency', columnPipe: { pipe: new CurrencyPipe('de-DE', 'EUR') } } },

    { columnDescription: `Preis DC`, property: 'priceDc', options: {
      tdStyleClasses: 'currency', columnPipe: { pipe: new CurrencyPipe('de-DE', 'EUR') } } },

    { columnDescription: `Startgebühr`, property: 'startingFeeAmount', options: {
      tdStyleClasses: 'currency', columnPipe: { pipe: new CurrencyPipe('de-DE', 'EUR') } } },

    { columnDescription: `Benutzer`, property: 'selectedUsers', options: {
      tdStyleClasses: 'users', isLength: true } },
  ];

  public tableOptions: TableOptions = {
    hideActions: false,
    hideSearchAll: true,
    rowRouterLink: 'edit/{id}'
  };

  constructor(
    public pricingsService: PricingsService,
    public stripeInfosService: StripeInfosService,
    private usersService: UsersService,
    private customerService: CustomersService,
    injector: Injector
  ) {
    super(pricingsService, injector)
  }

  ngOnInit(): void {
    this.getRoles();
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
    super.ngOnInit();
  }

  getTime(date?: Date) {
    return new Date(date) != null ? new Date(date).getTime() : 0;
  }

  async initializeEntities() {
    if (this.parent_operator) {
      this.customerService.getMasterUserOfCustomerAsync(this.activatedRoute.parent.snapshot.params.key).then(masterUser => {
          this.userId = masterUser.id;
          this.getPricingOfUser();
      })
    }
    else {
      this.userId = localStorage.getItem('userId');
      this.getPricingOfUser();
    }    
  }

  getPricingOfUser() {
    this.pricingsService.getPricingsOfUser(this.userId).subscribe(result => {
      this.entities = plainToClass(PricingDto, result)

      if (this.entities) {
        for (const entity of this.entities) {
          // entity.type = entity.isPublic ? 'QR-Code' : entity.priceId ? 'Abonnement' : 'Rechnung'
          switch(entity.billingMethod){
            case BillingMethodEnum.Manual:
              entity.type = 'Manuell';
              break;
            case BillingMethodEnum.QRCode:
              entity.type = 'QR-Code';
              break;
            case BillingMethodEnum.Automatic:
              entity.type = 'Abonnement';
              break;
          }
            
        }

        this.entities = this.entities.sort((a, b) => {return this.getTime(b.created) - this.getTime(a.created)})
        
        super.setupTable()
      }

      this.stripeInfosService.getStripeInfoOfUser(this.userId).subscribe(result => {
        this.hasStripeAccount = result.stripeAccountId != null
      })
    }, error => console.error(error))
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Customer')) {
      this.customer = true;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.operator = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.user = true;
    }
    this.isSupporter = this.authenticationService.userHasRole('Supporter')
  }

  matches(entity: PricingDto, term: string) {
    return PricingsService.matches(entity, term)
  }
}
